import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { getHeightForRows, SortableDataGrid } from '~src/commonInfra/components/dataGrid/SortableDataGrid3';
import { ISliceable } from '~src/httpClient/fetchers/ISliceable';
import { SliceableHelper } from '~src/httpClient/utils/SliceableHelper';
import { IOrderClause } from '~src/spacesPlatform/serverApi/types/IOrderClause';
import { applyColor }from '~src/style/ColorService';

import { flowParametersColumns, FlowParametersGridRow } from '../FlowParametersColumns';
import { FlowParameter, FlowParameterParams } from '../types/FlowParameters';
import { getFlowTimestampTypeName, isTimestampParameter } from '../utils/FlowParametersUtils';


const parametersDatagridStyle = style({
  border: `1px solid ${applyColor(DesignTokens.color.elevation.border.default.subtle, TabStyles.Colors.L6)}`,
});

function getRowData(parameters: FlowParameter[], parameterParams: FlowParameterParams[]): (orderClause: IOrderClause[]) => ISliceable<FlowParametersGridRow> {
  const parameterRows = parameters.map(parameter => {
    let parameterName = parameter.name;
    let parameterValue = parameter.value;
    let parameterDescription = parameter.description;
    if (parameterParams !== undefined) {
      const matchingOverride = parameterParams.find(parameterParam => parameterParam.id === parameter.id);
      if (matchingOverride !== undefined) {
        parameterValue = matchingOverride.overrideValue;
      }
    }
    if (isTimestampParameter(parameter)) {
      parameterName = getFlowTimestampTypeName(parameter.value);
      parameterValue = Messages.flowParametersSystemGenerated();
      parameterDescription = Messages.flowParametersSystemDescription();
    }
    return {
      parameterName,
      parameterValue,
      parameterDescription,
    };
  });
  return (_orderClause: IOrderClause[]) => SliceableHelper.fromArray(parameterRows);
}

export interface FlowParametersGridProps {
  parameters: FlowParameter[];
  parameterParams?: FlowParameterParams[]; // Override Values for Parameters
}

export function FlowParametersGrid(props: FlowParametersGridProps): JSX.Element {
  const sliceable = React.useMemo(
    () => getRowData(props.parameters, props.parameterParams),
    [props.parameters, props.parameterParams]
  );

  const parameterCount = Object.keys(props.parameters).length;

  const columns = flowParametersColumns();
  return (
    <div className={parametersDatagridStyle} style={{ height: getHeightForRows(parameterCount + 1) - 3 }}>
      <SortableDataGrid
        columns={columns}
        getSliceable={sliceable}
      />
    </div>
  );
}
